/**
 * This file is kept for backward compatibility and to avoid updating every import in the Web app.
 * All new Sentry-related code should live in and be imported directly from "@punchup/sentry".
 */

import {
  NamedError as _NamedError,
  SentryFeatureTags as _SentryFeatureTags,
  type OurSentryAdditionalData as _OurSentryAdditionalData,
  type OurSentryAdditionalDataPlus as _OurSentryAdditionalDataPlus,
  logSupabaseException as _logSupabaseException,
  logException as _logException,
  logValidationError as _logValidationError,
  logMessage as _logMessage,
  runFunctionWithSpan as _runFunctionWithSpan,
  cleanupSentryErrorEvent as _cleanupSentryErrorEvent,
} from "@punchup/sentry";

/**
 * @deprecated import from "@punchup/sentry" package instead
 */
export class NamedError extends _NamedError {}

/**
 * @deprecated import from "@punchup/sentry" package instead
 */
export const SentryFeatureTags = _SentryFeatureTags;

/**
 * @deprecated import from "@punchup/sentry" package instead
 */
export type OurSentryAdditionalData = _OurSentryAdditionalData;

/**
 * @deprecated import from "@punchup/sentry" package instead
 */
export type OurSentryAdditionalDataPlus = _OurSentryAdditionalDataPlus;

/**
 * @deprecated import from "@punchup/sentry" package instead
 */
export const logSupabaseException = _logSupabaseException;

/**
 * @deprecated import from "@punchup/sentry" package instead
 */
export const logException = _logException;

/**
 * @deprecated import from "@punchup/sentry" package instead
 */
export const logValidationError = _logValidationError;

/**
 * @deprecated import from "@punchup/sentry" package instead
 */
export const logMessage = _logMessage;

/**
 * @deprecated import from "@punchup/sentry" package instead
 */
export const runFunctionWithSpan = _runFunctionWithSpan;

/**
 * @deprecated import from "@punchup/sentry" package instead
 */
export const cleanupSentryErrorEvent = _cleanupSentryErrorEvent;
